import { render, staticRenderFns } from "./ssjk_dp.vue?vue&type=template&id=03a5fb20&scoped=true&"
import script from "./ssjk_dp.vue?vue&type=script&lang=js&"
export * from "./ssjk_dp.vue?vue&type=script&lang=js&"
import style0 from "./ssjk_dp.vue?vue&type=style&index=0&id=03a5fb20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5fb20",
  null
  
)

export default component.exports